<template>
  <div
    class="form-page-toolbar flex min-w-0 flex-col gap-4 md:flex-row md:flex-wrap md:items-center md:justify-between"
  >
    <Heading
      :level="1"
      class="min-w-0 text-xl font-bold tracking-tight text-zinc-900 dark:text-white md:text-2xl"
      :dusk="headingDusk"
    >
      {{ title }}
    </Heading>

    <nav
      class="form-page-toolbar-dock mobile-fixed-chrome pointer-events-none fixed inset-x-0 bottom-0 z-40 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] md:pointer-events-auto md:static md:z-auto md:px-0 md:pb-0"
      :aria-label="__('Form actions')"
    >
      <div
        class="form-page-toolbar-actions pointer-events-auto flex w-full min-w-0 flex-row items-stretch gap-2 md:w-auto md:flex-wrap md:items-center md:gap-2"
      >
        <slot />
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },

    headingDusk: {
      type: String,
      default: 'form-heading',
    },
  },
}
</script>
